import React, { FC, memo, useMemo } from 'react'

import { Obj } from 'interfaces/common'
import { Plan } from 'pages/ReportPages/BuildReport/context/props'
import customDateReport from 'utils/formateDateReport'
import formatPrice from 'utils/formatPrice'

import { Page, Document, View, Text } from '@react-pdf/renderer'

import { PrintReportAltasProps } from './props'
import styles from './styles'

const PrintReportAltas: FC<PrintReportAltasProps> = ({ data }) => {
  const customTypeRevendedor: Obj = useMemo(
    () => ({
      all: 'todos',
      partner: 'parceira',
      franchisee: 'franqueada',
    }),
    [],
  )

  const date_gt = customDateReport({ date: String(data?.date_gt) })

  const date_lt = customDateReport({ date: String(data?.date_lt) })

  return (
    <Document>
      <Page size="A4">
        <View style={styles.container}>
          <View style={styles.containerTitle}>
            <Text style={styles.textTitle}>Relatório de Altas</Text>
          </View>

          <Text style={styles.textValueItem}>
            Tipo de revendedor:{' '}
            {customTypeRevendedor[String(data?.company_type_eq)]}
          </Text>
          <Text style={styles.textValueItem}>
            Período de {date_gt} á {date_lt}
          </Text>

          <Text style={styles.textValueItem}>
            Chips ativados: {data?.chips_purchased}
          </Text>
          <Text style={styles.textValueItem}>
            Chips aguardando venda: {data?.chips_awaiting_sale}
          </Text>
          <Text style={styles.textValueItem}>
            Chips ativados c/ recarga e pacote: {data?.chips_with_plans}
          </Text>
          <Text style={styles.textValueItem}>
            Chips ativados sem recarga e pacote: {data?.chips_without_plans}
          </Text>
          <Text style={styles.textValueItem}>
            Portabilidade/ migrações: {data?.chips_with_portability}
          </Text>
          <Text style={styles.textValueItem}>
            Chips removidos: {data?.chips_removed}
          </Text>
        </View>

        <View style={styles.containerTable}>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <View style={styles.tableCol1Header}>
                <Text style={styles.tableCellHeader}>Produto</Text>
              </View>
              <View style={styles.tableColHeader}>
                <Text style={styles.tableCellHeader}>Quantidade</Text>
              </View>
              <View style={styles.tableColHeader}>
                <Text style={styles.tableCellHeader}>Valor total</Text>
              </View>
            </View>

            {data?.plans?.map((plan: Plan) => (
              <View key={plan.description} style={styles.tableRow}>
                <View style={styles.tableCol1}>
                  <Text style={styles.tableCell}>{plan.description}</Text>
                </View>

                <View style={styles.tableCol1}>
                  <Text style={styles.tableCell}>{plan.quantity}</Text>
                </View>

                <View style={styles.tableCol1}>
                  <Text style={styles.tableCell}>
                    {formatPrice({ price: plan.total_value })}
                  </Text>
                </View>
              </View>
            ))}
          </View>
        </View>
      </Page>
    </Document>
  )
}

export default memo(PrintReportAltas)
